import React from "react";
import Typography from "@mui/material/Typography";
import MUIPopover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import theme from "@theme";

function Popover({
  buttonLabel,
  variant,
  popoverContent,
  buttonProps,
  popoverProps,
  sx,
}) {
  const handleClick = (event, popupState) => {
    event.stopPropagation();
    bindTrigger(popupState).onClick(event);
  };

  return (
    <PopupState variant="popover">
      {(popupState) => (
        <div>
          <div
            variant={variant}
            {...buttonProps}
            style={{
              ...sx,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: sx?.backgroundColor || theme.colors.themeColor,
              },
            }}
            onClick={(event) => handleClick(event, popupState)}
          >
            {buttonLabel.icon}
          </div>
          <MUIPopover
            {...bindPopover(popupState)}
            {...popoverProps}
            sx={{ zIndex: 2000, top: "21px" }}
            onClose={(event) => {
              event.stopPropagation(); // Stop event from bubbling up
              popupState.close(); // Close the popover
            }}
          >
            <Typography sx={{ p: 2 }}>
              {React.cloneElement(popoverContent, { popupState })}
            </Typography>
          </MUIPopover>
        </div>
      )}
    </PopupState>
  );
}

export default Popover;
